/**
 * 工序描述（SAP 长文本）展示格式化。
 *
 * 新同步的数据由后端按 TDFORMAT 保留了换行，原样展示即可；
 * 历史数据的换行在同步时已丢失，只能按文本痕迹推断断行：
 *  - 3 个以上连续空格（原 SAP 行首缩进/行尾补齐的残留）
 *  - 列表编号：1)  1）  1、  1．  1.  (1)  （1）  ①
 *  - 句号/分号后的工种前缀：钳 / 检 / 车 / 外协 ...
 */

// 工种前缀取自开发库 prd_pp_operation 的高频值，必须后跟空格才算
const WORK_CENTER_PREFIX = '(?:钳\\+焊|镗铣|线切割|热处理|外协|喷砂|喷漆|喷丸|喷涂|超速|物流|防腐|下料|钳|检|车|铣|镗|焊|划|钻|磨|热|锯)';
const WORK_CENTER_RE = new RegExp(`([。；;.])\\s*(${WORK_CENTER_PREFIX} )`, 'g');

// 编号前一个字符不能是字母/数字/小数点/斜杠等，避免误伤 φ650、Ra6.3、Div.1、1/3级
const NUMBER_BEFORE = '(^|[^0-9A-Za-z.．/\\-_φΦ])';
const NUMBER_STYLES = [
    // 1)  1）  —— 排除 (1) （1）形式，交给下一条
    {marker: '[)）]', before: '(^|[^0-9A-Za-z.．/\\-_φΦ(（])'},
    {marker: '、'},
    {marker: '．'},
    // 1.  —— 后面不能是数字（排除 6.3 这类小数）
    {marker: '\\.(?![0-9])'},
];

function breakBeforeNumbers(text) {
    let result = text;
    NUMBER_STYLES.forEach(({marker, before = NUMBER_BEFORE}) => {
        // 句读之后的编号直接断行；其它位置要求文本里出现过「1+同样的标记」，降低误判
        const strong = new RegExp(`([。；;：:])\\s*([1-9][0-9]?${marker})`, 'g');
        result = result.replace(strong, '$1\n$2');
        if (new RegExp(`${before}1${marker}`).test(result)) {
            result = result.replace(new RegExp(`${before}([1-9][0-9]?${marker})`, 'g'), '$1\n$2');
        }
    });
    if (/[(（]1[)）]/.test(result)) {
        result = result.replace(/([^\n])([(（][1-9][0-9]?[)）])/g, '$1\n$2');
    }
    return result.replace(/([^\n])([①-⑳])/g, '$1\n$2');
}

export function formatOperationDescription(value) {
    if (value === null || value === undefined) {
        return '';
    }
    let text = String(value).replace(/<\(>/g, '(').replace(/<\)>/g, ')');
    if (/[\r\n]/.test(text)) {
        return text.replace(/\r\n?/g, '\n');
    }
    text = text.replace(/ {3,}/g, '\n');
    text = text.replace(WORK_CENTER_RE, '$1\n$2');
    text = breakBeforeNumbers(text);
    return text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line)
        .join('\n');
}

export default formatOperationDescription;
